export default __webpack_public_path__ + "static/media/3.33b3e21f.svg";